var detect=require('is-client');var scrollmagic=undefined;if(detect()){scrollmagic=require('scrollmagic');}export default scrollmagic;